<template>
    <div class="searchWithTable">
        <div class="searchWithTable__container">
          <div class="container__header--container d-flex flex-between align-items-end">
            <div class="header-content">
              <div class="header primary-default-text-color">{{ $t(camelize(headerText)) }}</div>
            </div>
            <div class="header-icons d-flex justify-content-end align-items-end" v-if="uploadBtn">
              <div class="header-upload emergo-primary-text mr-40" ><button @click="uploadHeaderOperation" class="btn emergo-btn pt-0 flex align-items-center"><img src="/static/images/icons/upload_new.svg"/>{{ $t('uploadFile') }}</button></div>
              <!-- <div class="header-download emergo-primary-text"><img src="/static/images/icons/DownloadTemplate.svg"/><button :disabled="true">Download</button></div> -->
              <!-- <div class="header-delete emergo-delete-text"><button @click="deleteEntry('bulk')" class="btn emergo-btn pt-0 flex align-items-center" type="button" :disabled="disableDeleteBtn"><img src="/static/images/icons/Trash.svg"/>Delete</button></div> -->
            </div>
          </div>
            <div class="container__tabs--container">
              <ul class="tabNames d-flex">
                <li class="tabName" v-for="tab in tabNames" :key="tab.id" :class="tab.id === activeTab ? 'active':''" @click="tabSelection"><span>{{ $t(camelize(tab.tabName.split(" ").join(""))) }}</span></li>
              </ul>
            </div>
            <div class="container__search--container d-flex">
              <div class="searchResultsNumber">{{ totalSearchItems }} {{$t('itemsLabel')}}</div>
              <div class="search-bar--container">
                <img class="searchBarIcon" src="/static/images/icons/search_UL.svg" />
                <input type="text" v-model="searchTerm" :placeholder="searchPlaceholder" v-on:keyup="searchEntries"/>
              </div>
            </div>
            <div class="container__item-list--container">
              <div class="item-list-select-all">
                <!-- <div class="checkbox-wrapper">
                  <label class="custom-checkbox">
                    <input type="checkbox" id="files" v-model="selectAllCheckbox" @change="checkAllFiles"/>
                    <span class="select-check"></span>
                  </label>
                </div> -->
                <label class="d-flex" v-for="tableLabel in tableLabels" :key="tableLabel"><span class="file-category fw-600 primary-default-text-color">{{ $t(camelize(tableLabel).split(" ").join("")) }}</span><div class="select-all--cheveron-container ml-10 sort-key cursor-pointer" :class="sortList?'asc':'dsc'" @click="sortEntries">
                </div></label>
              </div>
              <ul v-if="activeTab === 1" class="fileList--container">
                <li class="fileList d-flex align-items-center" v-for="(fileItem,index) in duplicateFilesArray" :key="fileItem.attachmentId">
                  <div class="item-checkbox--container d-flex">
                    <!-- <div class="checkbox-wrapper">
                      <label class="custom-checkbox">
                        <input type="checkbox" :value="fileItem.attachmentId" class="file-entry" v-model="selectedFiles"/>
                        <span class="select-check"></span>
                      </label>
                    </div> -->
                    <!-- <input type="checkbox" :value="fileItem.id" class="file-entry" v-model="selectedFiles"/> -->
                    <label class="d-flex flex-between"><div class="fileName primary-default-text-color">{{ fileItem.fileName }}</div>
                      <div v-if="deleteBtn" class="delete-entry delete-icon-text flex align-center" @click="deleteEntry('',fileItem, index)">
                        <img src='/static/images/icons/Trash.svg'/>
                        <span class="emergo-delete-text ml-5">{{ $t('delete') }}</span>
                      </div>
                      <div v-if="downloadBtn" class="download-entry" @click="downloadEntry(fileItem)">
                        <img src='/static/images/icons/DownloadTemplate.svg'/>
                        <span class="emergo-primary-text ml-5">Download</span>
                      </div>
                    </label>
                </div>
                </li>
                <li class="fileList emptyFileList" v-if="duplicateFilesArray.length <= 0">
                  <div clss="flex justify-content-center">
                    <p class="primary-default-text-color">{{ $t('noFilesFound') }}</p>
                  </div>
                </li>
              </ul>
              <ul v-if="activeTab === 2" class="fileList--container">
                <li class="fileList d-flex align-items-center" v-for="(fileItem,index) in duplicateFilesArray" :key="fileItem.attachmentId">
                  <div class="item-checkbox--container d-flex">
                    <!-- <div class="checkbox-wrapper">
                      <label class="custom-checkbox">
                        <input type="checkbox" :value="fileItem.attachmentId" class="file-entry" v-model="selectedFiles"/>
                        <span class="select-check"></span>
                      </label>
                    </div> -->
                    <label class="d-flex flex-between"><div class="fileName primary-default-text-color">{{ fileItem.fileName }}</div>
                      <div v-if="deleteBtn" class="delete-entry delete-icon-text flex align-center" @click="deleteEntry('',fileItem, index)">
                        <img src='/static/images/icons/Trash.svg'/>
                        <span class="emergo-delete-text ml-5">{{ $t('delete') }}</span>
                      </div>
                      <div v-if="downloadBtn" class="download-entry" @click="downloadEntry(fileItem)">
                        <img src='/static/images/icons/DownloadTemplate.svg'/>
                        <span class="emergo-primary-text ml-5">Download</span>
                      </div>
                    </label>
                </div>
                </li>
                <li class="fileList emptyFileList" v-if="duplicateFilesArray.length <= 0">
                  <div clss="flex justify-content-center">
                    <p>{{ $t('noFilesFound') }}</p>
                  </div>
                </li>
              </ul>
              <ul v-if="activeTab === 3" class="fileList--container">
                <li class="fileList d-flex align-items-center" v-for="(fileItem,index) in duplicateFilesArray" :key="fileItem.attachmentId">
                  <div class="item-checkbox--container d-flex">
                    <!-- <div class="checkbox-wrapper">
                      <label class="custom-checkbox">
                        <input type="checkbox" :value="fileItem.attachmentId" class="file-entry" v-model="selectedFiles"/>
                        <span class="select-check"></span>
                      </label>
                    </div> -->
                    <label class="d-flex flex-between"><div class="fileName primary-default-text-color">{{ fileItem.fileName }}</div>
                      <div v-if="deleteBtn" class="delete-entry delete-icon-text flex align-center" @click="deleteEntry('',fileItem, index)">
                        <img src='/static/images/icons/Trash.svg'/>
                        <span class="emergo-delete-text ml-5">{{ $t('delete') }}</span>
                      </div>
                      <div v-if="downloadBtn" class="download-entry" @click="downloadEntry(fileItem)">
                        <img src='/static/images/icons/DownloadTemplate.svg'/>
                        <span class="emergo-primary-text ml-5">Download</span>
                      </div>
                    </label>
                </div>
                </li>
                <li class="fileList emptyFileList" v-if="duplicateFilesArray.length <= 0">
                  <div clss="flex justify-content-center">
                    <p>{{ $t('noFilesFound') }}</p>
                  </div>
                </li>
              </ul>
              <ul v-if="activeTab === 4" class="fileList--container">
                <li class="fileList d-flex align-items-center" v-for="(fileItem,index) in duplicateFilesArray" :key="fileItem.attachmentId">
                  <div class="item-checkbox--container d-flex">
                    <!-- <div class="checkbox-wrapper">
                      <label class="custom-checkbox">
                        <input type="checkbox" :value="fileItem.attachmentId" class="file-entry" v-model="selectedFiles"/>
                        <span class="select-check"></span>
                      </label>
                    </div> -->
                    <label class="d-flex flex-between"><div class="fileName primary-default-text-color">{{ fileItem.fileName }}</div>
                      <div v-if="deleteBtn" class="delete-entry delete-icon-text flex align-center" @click="deleteEntry('',fileItem, index)">
                        <img src='/static/images/icons/Trash.svg'/>
                        <span class="emergo-delete-text ml-5">{{ $t('delete') }}</span>
                      </div>
                      <div v-if="downloadBtn" class="download-entry" @click="downloadEntry(fileItem)">
                        <img src='/static/images/icons/DownloadTemplate.svg'/>
                        <span class="emergo-primary-text ml-5">Download</span>
                      </div>
                    </label>
                </div>
                </li>
                <li class="fileList emptyFileList" v-if="duplicateFilesArray.length <= 0">
                  <div clss="flex justify-content-center">
                    <p>{{ $t('noFilesFound') }}</p>
                  </div>
                </li>
              </ul>
            </div>
        </div>
    </div>
</template>
<script>
import {
  downloadFile
} from '../../apis/fileUploadDownload';

export default {
  name: 'DefaultSearchWithTable',
  props: {
    activeTab: {
      type: Number
    },
    headerText: {
      type: String
    },
    tabNames: { // Array should be in the format of [{id: 1, tabName: 'sample text'}]
      type: Array
    },
    tableLabels: { // Array should be in the format of ['sample text1', 'sample text2']
      type: Array
    },
    filesArray: { // Array should be in the format of [{id: 1, fileName: 'sample text'}]
      type: Array
    },
    deleteBtn: {
      type: Boolean
    },
    downloadBtn: {
      type: Boolean,
      default: false
    },
    registrationId: {
      type: Number
    },
    uploadBtn: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      totalSearchItems: null,
      searchTerm: '',
      camelizedText: '',
      selectAllCheckbox: false,
      sortList: false,
      duplicateFilesArray: [],
      selectedFiles: [],
      activeTabLocal: 0,
      deleteWarningInfo: {
        loaderStatus: false,
        title: '',
        customMessage: '',
      },
      headerTitle: '',
      recordIds: [],
      fileIndex: [],
      deletedIds: '',
      searchPlaceholder: ''
    };
  },
  watch: {
    selectedFiles(e) {
      if (e.length === this.filesArray.length) {
        this.selectAllCheckbox = true;
      } else {
        this.selectAllCheckbox = false;
      }
    }
  },
  mounted() {
    this.searchPlaceholder = this.$i18n.locale === 'Portuguese' ? 'Pesquisar' : 'Search';
    if (this.filesArray) {
      this.duplicateFilesArray = this.filesArray;
      this.totalSearchItems = this.duplicateFilesArray.length;
    } else {
      this.totalSearchItems = 0;
    }
  },
  methods: {
    sortEntries(e) {
      this.camelizedText = this.camelize(e.target.previousSibling.innerText);
      this.duplicateFilesArray.sort(this.entryCompare);
      this.sortList = !this.sortList;
    },
    checkAllFiles() {
      if (this.selectAllCheckbox) {
        // eslint-disable-next-line array-callback-return
        this.filesArray.map((fileItem) => {
          this.selectedFiles.push(fileItem.attachmentId);
        });
      } else {
        this.selectedFiles = [];
      }
    },
    camelize(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase())).replace(/\s+/g, '');
    },
    entryCompare(a, b) {
      if (this.sortList === true) {
        if (a[this.camelizedText] < b[this.camelizedText]) {
          return -1;
        }
        if (a[this.camelizedText] > b[this.camelizedText]) {
          return 1;
        }
        return 0;
      } if (this.sortList === false) {
        if (a[this.camelizedText] > b[this.camelizedText]) {
          return -1;
        }
        if (a[this.camelizedText] < b[this.camelizedText]) {
          return 1;
        }
        return 0;
      }
      return 0;
    },
    searchEntries() {
      const res = this.filesArray.filter((obj) =>
        JSON.stringify(obj.fileName).toLowerCase().includes(this.searchTerm.toLowerCase()));
      this.duplicateFilesArray = res;
      this.totalSearchItems = this.duplicateFilesArray.length;
    },
    uploadHeaderOperation() {
      this.$emit('uploadTableOperation', this.duplicateFilesArray);
    },
    deleteHeaderOperation() {
      this.$emit('deleteTableOperation', this.selectedFiles);
    },
    deleteEntry(type, fileItem, index) {
      this.deleteWarningInfo.loaderStatus = false;
      console.log(type, index, fileItem);
      this.fileIndex = this.filesArray.findIndex((fileItemIndex) => fileItemIndex.fileName === fileItem.fileName);
      if (!fileItem.file) this.deletedIds = fileItem.attachmentId;
      this.$emit('deleteAttachments', this.deletedIds, this.fileIndex);
    },
    tabSelection(e) {
      // eslint-disable-next-line array-callback-return
      this.tabNames.map((tab) => {
        this.activeTabLocal = this.activeTab;
        if (this.$t(this.camelize(tab.tabName)) === e.target.innerText) {
          this.activeTabLocal = tab.id;
          this.$emit('tableTabChanged', tab.id);
        }
      });
    },
    async downloadEntry(file) {
      await downloadFile(this.registrationId, file);
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property, consistent-return
    disableDeleteBtn() {
      if (this.uploadBtn) {
        return this.filesArray.length <= 0;
      }
    }
  }
};
</script>
<style scoped>

.container__header--container {
  margin-bottom: 27px;
}
.header-content, .header-icons {
  width: 50%;
}
.header {
  font-weight: 600;
  font-size: 18px;
}
.header-icons .header-upload {
  margin-right: 32px;
}
.header-icons div button{
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  border: none;
  background: none;
  padding-bottom: 0;
  padding-right: 0;
}

.header-icons div button[disabled] {
  cursor: not-allowed;
}

.header-icons div button:focus, .header-icons div button:hover {
  color: unset;
}

.header-icons div img{
  /* margin-left: 5px; */
  margin-right: 2px;
}
.tabNames {
  list-style: none;
  background: #F5F5F5;
  margin-bottom: unset;
  padding-inline-start: 1px;
  border: 1px solid #D3D3D3;
  border-bottom: unset;
}

.tabName {
  margin-left: 16px;
  margin-right: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #3E3E3E;
  cursor: pointer;
}

.tabName.active {
  border-bottom: 2px solid #01518A;
  font-size: 16px;
  font-weight: 400;
  color: #000001;
}

.container__search--container {
  height: 54px;
  border: 1px solid #D3D3D3;
}

.searchResultsNumber {
  width: 9%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 16px;
  border-right: 1px solid #D3D3D3;
  color: #4D4D4D;
  font-size: 14px;
  font-weight: 400;
}

.search-bar--container {
  width: 91%;
  position: relative;
}

.searchBarIcon {
  position: absolute;
  top: auto;
  bottom: 15px;
  left: 12px;
}

.search-bar--container input[type='text'] {
  width: 100%;
  height: 100%;
  border: none;
  padding-left: 48px;
}

.search-bar--container input[type='text']::placeholder {
  position: relative;
  left: -4px;
  color: #4D4D4D;
  font-size: 14px;
  font-weight: 400;
}

.search-bar--container input[type='text']:focus {
  outline: none;
}

.search-bar--container input[type='text']:focus::placeholder {
  color: transparent;
}

.item-list-select-all {
  height: 48px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  background: #E6E6E6;
}

.item-list-select-all input[type='checkbox'] {
  height: 16px;
  width: 16px;
  margin-top: 0px;
  outline: 2px solid #4D4D4D;
}

/* input[type=checkbox]:checked:after,input[type=checkbox]:checked:before {
  content: "\f14a";
} */

.item-list-select-all label {
  margin-bottom: 0;
  /* padding-left: 24px; */
}

.fileList--container {
  padding-inline-start: 1px;
  min-height: 220px;
  border: 1px solid #D3D3D3;
  /* border-top: unset; */
}
.emptyFileList  {
  background-color: unset !important;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fileList {
  list-style: none;
  height: 52px;
  padding-left: 15px;
}

.fileList:nth-child(even) {
  background: #F5F5F5;
}

.fileList:nth-child(odd) {
  background: #FAFAFA;
}

.fileList input[type='checkbox'] {
  height: 16px;
  width: 16px;
  margin-top: 0px;
  outline: 2px solid #4D4D4D;
}

.fileList label {
  width: 100%;
}

.fileName {
  flex-basis: 60%;
}

.item-checkbox--container {
  width: 100%;
}

.delete-entry,.download-entry {
  margin-right: 38px;
  cursor: pointer;
}

.delete-icon-text {
  font-size: 14px;
  font-weight: 400;
}

.delete-entry span, .download-entry span {
  /* margin-left: 5px; */
}

.delete-entry img{
  height: 18px;
  width: 18px;
  padding-right: 2px;
}

.primary-default-text-color {
    color: #3E3E3E;
}
</style>
